import { GroupChartE } from '@/components/ChartConstructor/ChartConstructor/types';
import { STORAGE_KEY_ROLE } from '@/constants/storage';
import { getItem } from '@/utils/storage';
import isArray from 'lodash/isArray';

const user = {
  adv: {
    // 'ecpa', 'avgCpc', 'compareAvgCpc',
    summaryColumns: ['grouped', 'subgrouped', 'eventsAdv', 'partnerCpc', 'cr', 'blendCr', 'compareCpc', 'compareCr', 'costCpaPP', 'avgVCpcRevPP', 'applies'],
    hiddenReportColumns: ['costCpaPP'],
    hiddenExportReportColumns: ['f[cost_cpa]'],
    reportingFilter: ['feedId', 'payType', 'type', 'paid'],
    widgetReconciliation: [GroupChartE.ADVERTISER, GroupChartE.DATE_ADV],
  },
  pub: {
    // 'ecpa', 'jobCount', 'avgCpc', 'compareAvgCpc',
    summaryColumns: ['grouped', 'subgrouped', 'eventsPub', 'cost', 'cr', 'tqfCr', 'unpaid', 'blendCr', 'compareCr', 'costCpaPP', 'costCpcPP', 'cntCostCpc', 'avgVCpcCostPP', 'applies'],
    hiddenReportColumns: ['costCpaPP', 'costCpcPP', 'cost', 'deltaPercentRev'],
    hiddenExportReportColumns: ['f[cost_cpa]', 'f[cost_cpc]', 'f[cost]'],
    reportingFilter: ['gloSrcId', 'payType', 'type', 'paid', 'gloSubSrc'],
    widgetReconciliation: [GroupChartE.GLO_SRC_ID, GroupChartE.DATE_PUB],
  },
  admin: {
    summaryColumns: ['grouped', 'subgrouped', 'groupedId', 'subgroupedId', 'editMatrix', 'churn24', 'jobsCount', 'manualEdrData', 'manualEdr', 'manualEdrDelta', 'manualEdrDeltaP', 'manualAvgEdr', 'jobCount', 'events', 'applies', 'unpaidP', 'cntCostCpc', 'cntRevCpc', 'cpc', 'avgCpc', 'avgVCpcCost', 'avgVCpaCost', 'avgVCpcRev', 'avgVCpaRev', 'ecpc', 'rev', 'revEcpa', 'agencyFee', 'totalCostPTP', 'cr', 'blendCr', 'edrPubFeed', 'edrAdvFeed', 'edrRev', 'netRoi', 'tqfCr', 'ipqsFraudScoreLimit', 'ipqsFraudScoreAvg', 'filteredPercent', 'fcr', 'ecpa', 'ecpac', 'cpa', 'costCpa', 'roi', 'roiTest', 'roiPercent', 'deltaEcpa', 'compareCpc', 'compareAvgCpc', 'compareRev', 'compareCost', 'compareCr', 'compareDeltaEcpa', 'compareDeltaRoi'],
    hiddenReportColumns: ['rev', 'compareRev', 'deltaPercentRev', 'edrAdvFeed', 'edrRev', 'roi', 'compareDeltaRoi', 'deltaPercentRoi', 'roiPercent', 'netRoi', 'revEcpa', 'compareDeltaEcpa', 'cpa', 'avgVCpcRev', 'avgVCpaRev', 'deltaRoi'],
    hiddenExportReportColumns: ['f[rev]', 'f[roi]', 'f[roi_percentage]', 'f[rev_ecpa]', 'f[partner_cpa]', 'f[v_rev_cpc_avg]', 'f[v_rev_cpa_avg]'],
  },
  trade: {
    summaryColumns: ['grouped', 'subgrouped', 'groupedId', 'subgroupedId', 'editMatrix', 'churn24', 'jobsCount', 'manualEdrData', 'manualEdr', 'manualEdrDelta', 'manualEdrDeltaP', 'manualAvgEdr', 'jobCount', 'events', 'applies', 'unpaidP', 'cntCostCpc', 'cntRevCpc', 'cpc', 'avgCpc', 'avgVCpcCost', 'avgVCpaCost', 'avgVCpcRev', 'avgVCpaRev', 'ecpc', 'rev', 'revEcpa', 'agencyFee', 'totalCostPTP', 'cr', 'blendCr', 'edrPubFeed', 'edrAdvFeed', 'edrRev', 'netRoi', 'tqfCr', 'ipqsFraudScoreLimit', 'ipqsFraudScoreAvg', 'filteredPercent', 'fcr', 'ecpa', 'ecpac', 'cpa', 'costCpa', 'roi', 'roiTest', 'roiPercent', 'deltaEcpa', 'compareCpc', 'compareAvgCpc', 'compareRev', 'compareCost', 'compareCr', 'compareDeltaEcpa', 'compareDeltaRoi'],
    hiddenReportColumns: ['rev', 'compareRev', 'deltaPercentRev', 'edrAdvFeed', 'edrRev', 'roi', 'compareDeltaRoi', 'deltaPercentRoi', 'roiPercent', 'netRoi', 'revEcpa', 'compareDeltaEcpa', 'cpa', 'avgVCpcRev', 'avgVCpaRev', 'deltaRoi'],
    hiddenExportReportColumns: ['f[rev]', 'f[roi]', 'f[roi_percentage]', 'f[rev_ecpa]', 'f[partner_cpa]', 'f[v_rev_cpc_avg]', 'f[v_rev_cpa_avg]'],
  },
};

export const roles = !process.env.REACT_APP_EFC ? [
  { key: 'adv', value: 'Advertiser' },
  { key: 'pub', value: 'Publisher' },
] : [
  { key: 'admin', value: 'Trade Desk' },
  { key: 'trade', value: 'Trade Desk' },
];

export const getRole = () => getItem(STORAGE_KEY_ROLE) || '';

export const isRole = (role: string | string[]) => {
  const storageRole = getRole();
  if (isArray(role)) {
    return role.includes(storageRole);
  }
  return storageRole === role;
};

export default user;
